import { render, staticRenderFns } from "./LogisticTab.vue?vue&type=template&id=1ce05366&"
import script from "./LogisticTab.vue?vue&type=script&lang=js&"
export * from "./LogisticTab.vue?vue&type=script&lang=js&"
import style0 from "./LogisticTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports